module.exports = __webpack_public_path__ + "img/logo-payon.3d61e0c0.svg";